import { styled } from 'styled-components'

import Spinner from 'core/components/lib/Spinner'

export const FooterBar = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  width: 100%;
`

export const RowsPerPage = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const Pager = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const getJustifyContent = (align?: 'left' | 'center' | 'right') => {
  if (align === 'right') return 'flex-end'
  if (align === 'center') return 'center'
  return 'flex-start'
}

export const SortableHeaderContent = styled.div<{ $align?: 'left' | 'center' | 'right' }>`
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: ${(p) => getJustifyContent(p.$align)};
`

export const TooltipContent = styled.span`
  display: block;
  text-align: left;
  text-transform: none;
  white-space: normal;
  font-size: 16px;
  font-weight: 400;
`

export const TableTextOverlay = styled.span`
  display: flex;
  position: absolute;

  /* Offset from top and bottom for compatibility with bordered wrappers */
  inset: 41px 0 4px;
  align-items: center;
  justify-content: center;
`

const Overlay = styled.span<{ $shaded?: boolean }>`
  display: flex;
  position: absolute;

  /* Offset from top and bottom for compatibility with bordered wrappers */
  inset: 4px 0;
  justify-content: center;
  z-index: 3;
  padding-top: 57px;
  ${(p) => p.$shaded && 'background: rgba(255, 255, 255, 0.85);'}
`

const FlexContainer = styled.span`
  display: flex;
  align-items: center;
  font-size: 20px;
`

export function TableLoadingOverlay() {
  return (
    <Overlay $shaded>
      <FlexContainer>
        <Spinner height='28px' position='relative' />
      </FlexContainer>
    </Overlay>
  )
}
